import {Load} from "./Load";
import {Basic} from "./Basic";

export class History
{
    static push_url(url)
    {
        window.history.pushState({v: url}, document.title, url);

        // update return url for ISE
        if(document.body.dataset.ise === 'on')
        {
            const iseExit = document.body.querySelector('.ise.ise--exit');
            if(iseExit)
            {
                iseExit.href = iseExit.href.replace(/url=.*/, 'url=' + document.location.pathname);
            }
        }
    }

    static replace_url()
    {
        let url = document.location.pathname;
        if(document.location.hash)
        {
            url += document.location.hash;
        }
        window.history.replaceState({v: url}, '', url);
    }

    static add_event()
    {
        window.addEventListener('popstate',e =>
        {
            if(e.state && e.state.v)
            {
                Load.post({
                    'f': 'load',
                    'url': e.state.v
                }).then(r =>
                {
                    Basic.update_page(r);
                }).catch(r =>
                {
                    console.error(r, e.state.v);
                });
            }
        });
    }
}
